import Backbone from 'backbone';
import _ from 'underscore';

Backbone.$ = $;

export default Backbone.View.extend({
  fetchCSV() {
    const url = this.csvFunc(this.params);
    window.open(url);
  },

  hide() {
    this.$el.css('display', 'none');
  },

  initialize() {
    const that = this;
    $('#toCSV').click((event) => {
      event.preventDefault();
      that.fetchCSV();
    });
    this.setCsvFunc();
  },

  setCsvFunc() {
    // Override
  },

  show(params) {
    this.params = _.extend(
      {
        format: 'csv',
      },
      params,
    );
    this.$el.css('display', 'inherit');
  },
});
